import React, {  Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

class SubstituteProductOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
			data: null,
			selectedItem: '',
			errorMessage: ''
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog('SubstituteProductOverlayDialog');
		this.props.resetSelectedSKU && this.props.resetSelectedSKU();
    }
	// format up to 2 decimal
    formatNumber2Decimal(number) {
        number = (number)?number.trim().replace(/,/g,""):number;
        if(number) {
            number = number.replace("$","");
            number = "$"+parseFloat(number).toFixed(2);
            return number === "$0.00"?"--":number;
        } else {
            return "--";
        }
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
        const { selectedRDD } = this.props;
        const data = this.props.substituteSKUData.filter(item => (item.availability && parseInt(item.availability, 10) > 0) || moment(item.eta).isBefore(selectedRDD));
		this.setState({
			showDialog: this.props.showDialog,
			data
		})
	}
	handleYes(event) {
		event.preventDefault();
		if(this.state.selectedItem === '') {
			this.setState({
				errorMessage: 'Please selected upgrade item.'
			})
		} else {
			this.props.handleUpgradeItem(_.find(this.state.data, ['item', this.state.selectedItem]), 'substitute');
		}
	}
	setSubstituteItem(event) {
		this.setState({
			selectedItem: event.target.value
		})
	}
    render() {
        return (
			<div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="substituteProductOverlayDialog" style={{top: '7%'}}>
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <div>
                        <h2 className="title">Substitute Product</h2>
                        <p>Substitute: <b>{this.state.data && this.state.data.sku}</b> for <b>{this.props.sku}</b></p>
                    </div>
					<p className="red bold">{this.state.errorMessage}</p>
                    <div style={{maxHeight: '296px', overflow: 'auto'}}>
		               {this.state.data && this.state.data.length > 0
	                    ? <div>
                            <p>Due to availability, we are offering you the following product at an equivalent price of the product you currently have selected to order.</p>
                            <p><b>Do you want to proceed with the following substitution?</b></p>
                            <table className="dataTableType2 substituteProductTable">
    	                        <thead>
    	                            <tr>
    	                                <th className="product">
    	                                    Product
    	                                </th>
    	                                <th className="availability">
    	                                    Availability
    	                                </th>
    	                                <th className="eta">
    	                                    ETA
    	                                </th>
    									<th className="select">
    										Select
    									</th>
    	                           </tr>
    	                        </thead>
    	                        <tbody>
    								{this.state.data.map((item, index) => {
    									return <tr key={index}>
    										<td className="product">
    											<b>{item.item}</b><br />
    											{item.itemDescription}
    										</td>
    										<td className="availability">
    											{item.availability}
    										</td>
    										<td className="eta">
                                                {item.eta && moment(item.eta).format('MM/DD/YY')}
    										</td>
    										<td className="select">
    											<input type="radio" name="upgrade_for_XXXXXXXXXXX" defaultValue={item.item} onClick={this.setSubstituteItem.bind(this)} />
    										</td>
    									</tr>
    								})}
    	                        </tbody>
    	                    </table>
                        </div>
						: <div>
                            <p>Based on current availability, we are not able to offer a substitute model.</p>
                            <p className="bold red">No substitute available for this item.</p>
                        </div>
					}
                    </div>
                    {this.state.data && this.state.data.length > 0 && <p className="orange">Please note that it may take up to 30 min to book your order with the substitute model.</p>}
                    <div className="noButtonContainer">
                        <a className="blueButton noButton" onClick={this.closeDialog.bind(this)}>No</a>
                    </div>
                    <div className="yesButtonContainer">
                        <a className="blueButton yesButton" onClick={this.handleYes.bind(this)}>Yes</a>
                    </div>
                </div>
            </div>
            );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

SubstituteProductOverlayDialog = connect(mapStateToProps)(SubstituteProductOverlayDialog);
export default SubstituteProductOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/substituteProductOverlayDialog.js